import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var isCurrentDay = function isCurrentDay(date) {
  var currentDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return currentDay[new Date().getDay()] === date;
};
export var pushHours = function pushHours(hours) {
  if (hours[0].date === 'Sunday') {
    // Sunday being 0 fix
    return [].concat(_toConsumableArray(hours.slice(1, 7)), [hours[0]]);
  }

  return hours;
};